<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" md="9" xl="10">
            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver Kardex de Pagos"
              small
              :disabled="itemsSeleccionados.length != 1 || obteniendoKardexPagos"
              :loading="obteniendoKardexPagos"
              @click="verKardexPagos">
              <v-icon>mdi-file-document</v-icon>

              Ver Kardex de Pagos
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoInscripcionProgramaUniversidad
              ref="listadoRef"
              :items="items"
              row-selection="multiple"
              :cargando="cargando"
              :itemsYaSeleccionados="detallesSolicitudesPagos"
              :itemsYaSolicitados="detallesSolicitudesPagosYaSolicitados"
              :mostrar-columna-solicitado="true"
              :seleccion-todos="false"
              :mostrarColumnaCuotaAnterior="true"
              :detallePagoConceptoUniversidadCuotaAnterior="detallePagoConceptoUniversidadCuotaAnterior"
              :inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior="
                inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior
              "
              :esLargo="true"
              :detallePlanPagoConceptoUniversidad="detallePlanPagoConceptoUniversidad"
              @selectItem="selectItem" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando || itemsSeleccionados.length == 0"
          :loading="enviando"
          @click.prevent="agregarDetallesSolicitudesPagos">
          Agregar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="mostradoKardexPagos" max-width="1000px" scrollable>
      <v-card style="overflow-y: hidden">
        <v-card-title class="py-2 px-4">Kardex de Pagos</v-card-title>

        <v-divider class="my-0"></v-divider>

        <v-card-text class="pa-4">
          <v-simple-table fixed-header height="400px">
            <thead>
              <tr>
                <th class="text-left">CONCEPTO</th>
                <th class="text-left">N° DE CUOTA</th>
                <th class="text-left">FECHA VENCIMIENTO</th>
                <th class="text-left">ASIGNACION MENSUAL</th>
                <th class="text-left">SALDO</th>
                <th class="text-left">PLAZO DE PAGO</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pago in kardexPagos" :key="pago.id">
                <td>{{ pago.concepto_pago }}</td>
                <td class="text-right">{{ pago.nro_cuota }}</td>
                <td class="text-center">{{ pago.fecha_pago }}</td>
                <td class="text-right">{{ formatearValorAMoneda(pago.total) }}</td>
                <td class="text-right">{{ formatearValorAMoneda(pago.saldo) }}</td>
                <td
                  :style="{
                    color:
                      pago.plazo_pago == 'NO CANCELADO' ? 'red' : pago.plazo_pago == 'CANCELADO' ? 'green' : 'orange',
                  }">
                  {{ pago.plazo_pago }}
                </td>
              </tr>

              <tr>
                <td colspan="2" class="text-right">TOTAL</td>
                <td></td>
                <td class="text-right">
                  {{ formatearValorAMoneda(kardexPagos.reduce((acc, pago) => acc + pago.total, 0)) }}
                </td>
                <td class="text-right">
                  {{ formatearValorAMoneda(kardexPagos.reduce((acc, pago) => acc + pago.saldo, 0)) }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click.prevent="mostradoKardexPagos = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import ListadoInscripcionProgramaUniversidad from './ListadoInscripcionProgramaUniversidad.vue';
import layoutMixin from '../mixins/layout.mixin';
import InscripcionProgramaUniversidadService from '../services/inscripcion-programa-universidad.service';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import SolicitudPagoService from '../services/solicitud-pago.service';
import cuotaAnteriorMixin from '../mixins/cuota-anterior.mixin';
import DetallesPlanPagosConceptoUniversidadService from '../services/detalles-plan-pagos-concepto-universidad.service';
import xaxios from '@/xaxios';
import { formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ModalFormularioDetallesSolicitudesPagos',
  mixins: [modalFormMixin, layoutMixin, apiConsumerMixin, cuotaAnteriorMixin],
  components: {
    ListadoInscripcionProgramaUniversidad,
  },
  props: {
    programaUniversidadId: {
      type: [Number, null],
      default: null,
    },
    detallesSolicitudesPagos: {
      type: Array,
      default: () => [],
    },
    detallePlanPagoConceptoUniversidadId: {
      type: Number,
      default: null,
    },
    planPagoUniversidadId: {
      type: [Number, null],
      default: null,
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Pago',
      itemsSeleccionados: [],
      solicitudPagoProgramaUniversidadIdDetallePlanPagoConceptoUniversidadId: [],
      detallePlanPagoConceptoUniversidad: null,
      kardexPagos: [],
      obteniendoKardexPagos: false,
      mostradoKardexPagos: false,
    };
  },
  computed: {
    detallesSolicitudesPagosYaSolicitados() {
      return this.solicitudPagoProgramaUniversidadIdDetallePlanPagoConceptoUniversidadId
        .map((item) => item.detallesSolicitudesPagos)
        .flat();
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaUniversidadId: this.programaUniversidadId,
        detallePlanPagoConceptoUniversidadId: null,
        detallesSolicitudesPagos: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaUniversidadId: data.programaUniversidadId,
        detallePlanPagoConceptoUniversidadId: data.detallePlanPagoConceptoUniversidadId,
        detallesSolicitudesPagos: data.detallesSolicitudesPagos,
      };
    },
    abrir(accion, data = []) {
      const planPagoUniversidadId = this.planPagoUniversidadId;
      const detallePlanPagoConceptoUniversidadId = this.detallePlanPagoConceptoUniversidadId;

      this.itemsSeleccionados = [];

      Promise.all([
        this.obtenerDetallePagoConceptoUniversidadCuotaAnterior(
          planPagoUniversidadId,
          detallePlanPagoConceptoUniversidadId,
        ),
        this.obtenerPagosUniversidadesCuotaAnterior(planPagoUniversidadId, detallePlanPagoConceptoUniversidadId),
        this.obtenerSolicitudPagoPorProgramaUniversidadIdYDetallePlanPagoConceptoUniversidadId(),
        this.obtenerDetallePlanPagoConceptoUniversidad(),
      ]).then(() => {
        this.abrirMixin(accion, data);
        this.listar();
      });
    },
    listar() {
      this.items = [];
      this.itemsSeleccionados = [];

      const params = {
        programaUniversidadId: this.programaUniversidadId,
      };

      this.obtenerDatosConNotificacion(
        InscripcionProgramaUniversidadService.findAll,
        'items',
        'INSCRIPCIONES PROGRAMAS UNIVERSIDADES',
        params,
      );

      this.item = null;
    },
    selectItem(items) {
      this.itemsSeleccionados = items || [];
    },
    agregarDetallesSolicitudesPagos() {
      this.$emit('agregarDetallesSolicitudesPagos', this.itemsSeleccionados);
      this.cerrar();
    },
    async obtenerSolicitudPagoPorProgramaUniversidadIdYDetallePlanPagoConceptoUniversidadId() {
      const params = {
        programaUniversidadId: this.programaUniversidadId,
        detallePlanPagoConceptoUniversidadId: this.detallePlanPagoConceptoUniversidadId,
      };
      this.solicitudPagoProgramaUniversidadIdDetallePlanPagoConceptoUniversidadId = [];

      await this.obtenerDatosMixin(
        SolicitudPagoService.findAllPorProgramaUniversidadDetallePlanPagoConceptoUniversidadId,
        'solicitudPagoProgramaUniversidadIdDetallePlanPagoConceptoUniversidadId',
        params,
        () => {},
        () => {
          this.itemsSeleccionados = [];
        },
      );
    },
    async obtenerDetallePlanPagoConceptoUniversidad() {
      await this.obtenerDatosV2Mixin(
        DetallesPlanPagosConceptoUniversidadService.findOne,
        'detallePlanPagoConceptoUniversidad',
        this.detallePlanPagoConceptoUniversidadId,
        null,
        () => {},
        () => {
          this.itemsSeleccionados = [];
        },
      );
    },
    async verKardexPagos() {
      if (this.itemsSeleccionados.length != 1) {
        return;
      }

      const itemSeleccionado = this.itemsSeleccionados[0];
      const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${itemSeleccionado.inscripcionId}/plan-pago/kardex`;

      this.kardexPagos = [];
      this.obteniendoKardexPagos = true;

      try {
        const response = await xaxios.get(url);

        const data = response.data;
        this.kardexPagos = data.data;
        this.mostradoKardexPagos = true;

        this.$notify({
          group: 'notifications',
          title: 'Kardex de Pagos',
          text: 'Kardex de Pagos recuperado con éxito',
          type: 'success',
        });
      } catch (error) {
        this.$notify({
          group: 'notifications',
          title: 'Kardex de Pagos',
          text: 'Error al recuperar Kardex de Pagos',
          type: 'error',
        });
      } finally {
        this.obteniendoKardexPagos = false;
      }
    },
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
  },
};
</script>